import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import Icon from '@hydra/common/components/Icon';
import Flag from '@hydra/common/components/Flag';
import SafeAnchor from '@hydra/common/components/SafeAnchor';
import tldToCountryCode from '@hydra/utils/tldToCountryCode';
import getWooIndexLink from '@hydra/utils/getWooIndexLink';
import { useReviewContext } from '@hydra/common/context/review';

const useStyles = makeStyles(theme => ({
  top: { verticalAlign: 'top' },
  middle: { verticalAlign: 'middle' },
  global: { marginBottom: theme.spacing(1.5) }
}));

export const CriteriumTraficRankSection = ({ global: globalRank, local: localRank, country }) => {
  const { isPdf } = useReviewContext();
  const { numeral } = useI18n();
  const classes = useStyles();
  return (
    <div>
      <div className={classes.global}>
        {
          globalRank && globalRank > 0
            ? (
              <>
                <Icon type='hreflang' size='sm' />
                &nbsp;
                {
                  isPdf
                    ? (
                      <Translate
                        content='trafic_rank_global'
                        with={{ traficRankGlobal: numeral(globalRank) && numeral(globalRank).format() }}
                      />
                      )
                    : (
                      <SafeAnchor
                        href={getWooIndexLink()}
                        rel='nofollow noopener noreferrer'
                        target='_blank'
                        className={classes.top}
                      >
                        <Translate
                          content='trafic_rank_global'
                          with={{ traficRankGlobal: numeral(globalRank) && numeral(globalRank).format() }}
                        />
                      </SafeAnchor>
                      )
                }

              </>
              )
            : <Translate component='div' content='alexa_too_low_global' />
        }
      </div>
      {
        localRank && localRank > 0
          ? (
            <>
              <Flag country={tldToCountryCode(country)} />
              &nbsp;
              {
                isPdf
                  ? (
                    <>
                      <Translate
                        content='trafic_rank_site_country'
                        with={{ traficRankCountry: numeral(localRank) && numeral(localRank).format() }}
                      />
                      {' '}
                      <strong><Translate content={`country_name_${country}`} /></strong>
                    </>
                    )
                  : (
                    <SafeAnchor
                      href={getWooIndexLink(country)}
                      rel='nofollow noopener noreferrer'
                      target='_blank'
                      className={classes.middle}
                    >
                      <Translate
                        content='trafic_rank_site_country'
                        with={{ traficRankCountry: numeral(localRank) && numeral(localRank).format() }}
                      />
                      {' '}
                      <strong><Translate content={`country_name_${country}`} /></strong>
                    </SafeAnchor>
                    )
              }
            </>
            )
          : <Translate component='div' content='alexa_too_low_local' />
      }
    </div>
  );
};

CriteriumTraficRankSection.propTypes = {
  globalRank: PropTypes.number,
  localRank: PropTypes.number,
  country: PropTypes.string
};

export default CriteriumTraficRankSection;
